//const API_URL = 'http://192.168.101.200:8000'; // Localserver
//const API_URL = 'https://testifyrbackend.your-product.in'; // Production server
const API_URL = 'https://examappproductb01.your-product.in'; //production server 
export default API_URL;